import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Text } from "onefaceui-react-components";
import { getResourceTo } from 'react/utils/utils';

const DriverInfor = (props) => {
  const { stopData: { primaryDriver } } = props;
  const driverTitle =
    getResourceTo('Monet.RouteProgress.StopPopover.label.TitleDriver');
  const noDriverTitle =
    getResourceTo('Monet.RouteProgress.StopPopOver.NoDriverLabel')
      .toUpperCase();

  const driverData = useMemo(() => {
    const name = primaryDriver ?
      String(primaryDriver?.name).toUpperCase() :
      noDriverTitle;

    return {
      id: primaryDriver?.id || '',
      name,
    };
  }, [primaryDriver]);

  return (
    <footer>
      <Text size="xs" weight="regular" asChild>
        <span>{driverTitle}: {driverData.id} {driverData.name}</span>
      </Text>
    </footer>
  );
};

DriverInfor.propTypes = {
  stopData: PropTypes.object.isRequired,
};

export default DriverInfor;
